import { domain } from '../config/AppConfigurator';

export const login = async ( username, password, accessToken )=>{
    const response = await fetch(`${domain}/request/user/login`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`
          },
        body: JSON.stringify({
            "userName":  username ,
            "Password":  password ,
           })
    })
    return response.json();
}